import React, { useState } from 'react'

const css = `
  /* Fonts + body atmosphere load once globally (index.css -> styles/system.css).
     This page consumes the system tokens: var(--shadow-*), var(--r-*), var(--font-*). */
  * { box-sizing: border-box; margin: 0; padding: 0; }

  @keyframes mkPulse { 0%,100% { opacity: 1 } 50% { opacity: 0.4 } }
        @keyframes mkFade { from { opacity: 0; } to { opacity: 1; } }
  .mk-nav {
    background: rgba(251,248,242,0.82);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    box-shadow: 0 1px 0 rgba(56,62,48,0.05), 0 14px 30px -20px rgba(56,62,48,0.28);
    padding: 0 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .mk-logo { font-family: 'Fraunces', serif; font-size: 20px; font-weight: 500; color: #1C1C1C; letter-spacing: -0.3px; }
  .mk-logo-dot { color: #3D5C3C; }
  .mk-tabs { display: flex; gap: 2px; }
  .mk-tab { font-size: 13px; font-weight: 500; color: #73736A; padding: 6px 12px; border: none; background: none; cursor: pointer; transition: color 0.15s; letter-spacing: -0.1px; border-bottom: 2px solid transparent; }
  .mk-tab.active { color: #1C1C1C; font-weight: 500; border-bottom: 2px solid #3D5C3C; }
  .mk-tab:hover:not(.active) { color: #1C1C1C; }
  .mk-nav-right { display: flex; align-items: center; gap: 8px; }
  .mk-signin { font-size: 13px; color: #20241F; background: none; border: none; cursor: pointer; font-weight: 600; padding: 8px 12px; }
  .mk-signin:hover { color: var(--forest-500); }
  .mk-cta { background: var(--forest-500); color: white; border: none; border-radius: var(--r-pill); padding: 10px 20px; font-size: 13px; font-weight: 700; cursor: pointer; box-shadow: var(--shadow-pill); transition: transform var(--t-fast) var(--ease), box-shadow var(--t-fast) var(--ease); letter-spacing: -0.1px; }
  @media (hover: hover) { .mk-cta:hover { transform: translateY(-1px); } }
  .mk-cta:active { transform: scale(0.985); }
  .mk-menu-btn { display: none; font-size: 13px; color: #20241F; background: var(--paper); border: none; border-radius: var(--r-sm); cursor: pointer; font-weight: 600; padding: 8px 12px; box-shadow: var(--shadow-1); }
  .mk-nav-panel { display: none; }

  .mk-hero { position: relative; padding: 64px 64px 8px; overflow: hidden; }
  .mk-hero.dark { padding: 48px 40px; }
  .mk-hero.dark .mk-hero-centered {
    position: relative;
    border-radius: 28px;
    padding: 76px 48px;
    overflow: hidden;
    max-width: 1000px;
    background:
      radial-gradient(120% 90% at 85% 0%, rgba(139, 174, 138, 0.32), transparent 55%),
      linear-gradient(160deg, var(--forest-700) 0%, var(--forest-900) 70%);
    box-shadow: var(--shadow-3);
  }
  .mk-hero.dark .mk-hero-centered::before { content: ''; position: absolute; inset: -40%; background: radial-gradient(55% 45% at 68% 24%, rgba(139,174,138,0.16), transparent 62%); animation: mkDrift 16s ease-in-out infinite alternate; pointer-events: none; }
  @keyframes mkDrift { from { transform: translate3d(-4%, -2%, 0) scale(1); } to { transform: translate3d(4%, 3%, 0) scale(1.06); } }
  .mk-hero.dark .mk-hero-orb1 { position: absolute; top: -70px; left: -40px; width: 260px; height: 260px; border-radius: 50%; background: #8BAE8A; opacity: 0.12; pointer-events: none; animation: mkHeroGlow 6s ease-in-out infinite; }
  .mk-hero.dark .mk-hero-orb2 { position: absolute; bottom: -80px; right: -40px; width: 220px; height: 220px; border-radius: 50%; background: #E8941F; opacity: 0.06; pointer-events: none; }
  @keyframes mkHeroGlow { 0%, 100% { opacity: 0.07; } 50% { opacity: 0.14; } }
  .mk-hero-eyebrow { font-family: var(--font-mono); font-size: 11px; font-weight: 500; letter-spacing: 0.17em; color: rgba(139,174,138,0.95); text-transform: uppercase; margin-bottom: 22px; }
  .mk-price-line { font-size: 12.5px; color: rgba(250,248,244,0.5); margin-top: 14px; }
  .mk-hero-inner { max-width: 960px; margin: 0 auto; }
  .mk-hero-centered { max-width: 760px; margin: 0 auto; text-align: center; }
  .mk-h1.centered { max-width: 100%; margin-left: auto; margin-right: auto; }
  .mk-sub.centered { margin-left: auto; margin-right: auto; }
  .mk-actions.centered { justify-content: center; }
  .fmshow { display: grid; grid-template-columns: 1fr 1fr; gap: 48px; align-items: center; }
  @media (max-width: 800px) { .fmshow { grid-template-columns: 1fr; gap: 32px; } }
  .mk-tag { display: inline-flex; align-items: center; font-family: var(--font-mono); font-size: 10px; font-weight: 500; letter-spacing: 0.17em; text-transform: uppercase; color: var(--forest-500); margin-bottom: 14px; }
  .mk-h1 { font-family: var(--font-display); font-size: 60px; font-weight: 300; line-height: 1.04; margin-bottom: 18px; letter-spacing: -1.5px; max-width: 680px; color: var(--ink); }
  .mk-hero.dark .mk-h1 { color: #FAF8F4; }
  .mk-h1 em { font-style: italic; color: #3D5C3C; }
  .mk-hero.dark .mk-h1 em { color: #8BAE8A; }
  .mk-sub { font-size: 16px; color: #73736A; line-height: 1.7; margin-bottom: 30px; max-width: 520px; }
  .mk-hero.dark .mk-sub { color: rgba(250,248,244,0.68); font-weight: 300; }
  .mk-actions { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 36px; }
  .btn-p { background: var(--forest-500); color: #fff; border: none; border-radius: var(--r-md); padding: 15px 26px; font-size: 14px; font-weight: 700; cursor: pointer; box-shadow: var(--shadow-pill); transition: transform var(--t-fast) var(--ease), box-shadow var(--t-fast) var(--ease); }
  .mk-hero.dark .btn-g { background: rgba(250,248,244,0.1); color: #FAF8F4; box-shadow: none; }
  @media (hover: hover) { .btn-p:hover { transform: translateY(-1px); box-shadow: 0 14px 30px -6px rgba(61,92,60,0.5); } }
  .btn-p:active { transform: scale(0.985); }
  .btn-g { background: var(--paper); color: var(--ink-soft); border: none; border-radius: var(--r-md); padding: 14px 22px; font-size: 14px; font-weight: 600; cursor: pointer; box-shadow: var(--shadow-1); transition: transform var(--t-fast) var(--ease), box-shadow var(--t-fast) var(--ease), color var(--t-fast) var(--ease); }
  @media (hover: hover) { .btn-g:hover { transform: translateY(-1px); color: var(--forest-500); box-shadow: var(--shadow-2); } }
  .fmcard { background: radial-gradient(120% 90% at 85% 0%, rgba(139,174,138,0.18), transparent 55%), linear-gradient(160deg, var(--forest-700) 0%, var(--forest-900) 70%); border-radius: var(--r-lg); padding: 26px; position: relative; overflow: hidden; box-shadow: var(--shadow-3); }
  .fmcard-orb { position: absolute; top: -70px; right: -70px; width: 240px; height: 240px; border-radius: 50%; background: #8BAE8A; animation: mkGlow 5s ease-in-out infinite; pointer-events: none; }
  .fmcard-orb2 { position: absolute; bottom: -90px; left: -60px; width: 200px; height: 200px; border-radius: 50%; background: #E8941F; opacity: 0.05; pointer-events: none; }
  @keyframes mkGlow { 0%, 100% { opacity: 0.05; } 50% { opacity: 0.11; } }
  .fmcard::before { content: ''; position: absolute; top: -50px; right: -50px; width: 200px; height: 200px; background: radial-gradient(circle, rgba(139,174,138,0.14) 0%, transparent 65%); pointer-events: none; }
  .fmcard-eyebrow { font-family: var(--font-mono); font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.17em; color: rgba(139,174,138,0.8); margin-bottom: 7px; }
  .fmcard-title { font-family: var(--font-display); font-size: 22px; font-weight: 300; color: white; margin-bottom: 18px; }
  .fmcard-title em { font-style: italic; color: #8BAE8A; }
  .fmcard-foot { display: flex; justify-content: space-between; align-items: center; margin-top: 4px; padding-top: 14px; border-top: 1px solid rgba(255,255,255,0.08); }
  .fmcard-verify { font-family: 'DM Mono', monospace; font-size: 8.5px; color: rgba(255,255,255,0.3); letter-spacing: 0.4px; }

  .mk-section { padding: 72px 64px; max-width: 100%; }
  .mk-section-inner { max-width: 960px; margin: 0 auto; }
  /* MARKETING SURFACE (founder-approved 2026-11-03): soft warm slabs on a
     deeper paper page, forest only at the hero. Sections alternate between a
     lifted off-white slab and the bare paper, so every section has edges and
     nothing is ever a faint tint of its neighbor. Cards flip tone with their
     section through --card-bg so they always read as cards. No pure white
     surfaces larger than a card. */
  .mk-page { background: #E9E3D6; min-height: 100vh; position: relative; z-index: 0; }
  .mk-section { --card-bg: #F9F6EF; margin: 18px 24px; border-radius: 32px; background: transparent; }
  .mk-section:nth-child(odd of .mk-section) { background: #F9F6EF; box-shadow: 0 12px 32px -14px rgba(56,62,48,0.10); --card-bg: #FFFFFF; }
  .mk-section.alt, .mk-section.sage, .mk-section.cream { background: inherit; }
  .mk-section:nth-child(odd of .mk-section).alt, .mk-section:nth-child(odd of .mk-section).sage, .mk-section:nth-child(odd of .mk-section).cream { background: #F9F6EF; }
  @media (max-width: 640px) { .mk-section { margin: 12px 12px; border-radius: 24px; } }
  .ey { font-family: var(--font-mono); font-size: 10px; font-weight: 500; letter-spacing: 0.17em; text-transform: uppercase; color: var(--forest-500); margin-bottom: 14px; }
  .sh { font-family: var(--font-display); font-size: 30px; font-weight: 400; line-height: 1.22; margin-bottom: 14px; letter-spacing: -0.4px; color: var(--ink); }
  .sh em { font-style: italic; color: var(--forest-500); }
  .ss { font-size: 14px; color: #73736A; line-height: 1.75; max-width: 560px; margin-bottom: 40px; }

  .ph-head { display: flex; align-items: center; gap: 14px; margin-bottom: 26px; }
  .ph-badge { font-family: var(--font-mono); font-size: 10px; font-weight: 500; color: white; background: var(--forest-500); padding: 7px 14px; border-radius: var(--r-pill); flex-shrink: 0; letter-spacing: 0.14em; box-shadow: var(--shadow-pill); }
  .ph-name { font-family: var(--font-display); font-size: 28px; font-weight: 300; line-height: 1.05; }
  .ph-name em { font-style: italic; color: var(--forest-500); }
  .ph-time { font-family: var(--font-mono); font-size: 10px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--gray-faint); margin-top: 6px; }
  .spine { position: relative; padding-left: 44px; }
  .spine::before { content: ''; position: absolute; left: 15px; top: 8px; bottom: 8px; width: 2px; background: linear-gradient(#3D5C3C, rgba(61,92,60,0.15)); }
  .spine-step { position: relative; margin-bottom: 26px; }
  .spine-step:last-child { margin-bottom: 0; }
  .spine-dot { position: absolute; left: -36px; top: 2px; width: 16px; height: 16px; border-radius: 50%; background: white; border: 3px solid #3D5C3C; }
  .spine-tag { display: inline-block; font-family: var(--font-mono); font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.15em; color: var(--forest-500); background: var(--forest-100); padding: 4px 10px; border-radius: var(--r-pill); margin-bottom: 8px; }
  .spine-tag.amber { color: #8A887C; background: #EFEDE4; }
  .spine-title { font-size: 16px; font-weight: 600; margin-bottom: 6px; }
  .spine-desc { font-size: 13px; color: #7A7A72; line-height: 1.65; max-width: 520px; }
  .cyclebox { background: radial-gradient(110% 100% at 90% 0%, rgba(139,174,138,0.2), transparent 55%), linear-gradient(160deg, var(--forest-700), var(--forest-900) 75%); border-radius: var(--r-md); padding: 20px; margin-top: 16px; max-width: 520px; box-shadow: var(--shadow-3); }
  .cb-label { font-family: var(--font-mono); font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.17em; color: rgba(139,174,138,0.8); margin-bottom: 14px; }
  .cb-dots { display: flex; gap: 3px; margin-bottom: 10px; }
  .cb-dot { flex: 1; height: 9px; border-radius: 3px; }
  .cb-labels { display: flex; font-size: 10px; color: rgba(255,255,255,0.45); }
  @media (max-width: 700px) {
    .spine-desc, .cyclebox { max-width: 100%; }
    .ph-name { font-size: 22px; }
  }
  .sci-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
  .sci-card { background: var(--card-bg, var(--paper)); border-radius: var(--r-md); padding: 22px; box-shadow: var(--shadow-1); }
  .sci-icon { width: 36px; height: 36px; border-radius: 11px; background: #EDF3ED; display: flex; align-items: center; justify-content: center; margin-bottom: 14px; }
  .sci-t { font-size: 14px; font-weight: 500; margin-bottom: 7px; }
  .sci-d { font-size: 13px; color: #7A7A72; line-height: 1.7; }
  .sci-badge { display: inline-block; font-family: var(--font-mono); font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.12em; padding: 4px 10px; border-radius: var(--r-pill); background: var(--forest-100); color: var(--forest-500); margin-top: 12px; }
  .sci-compare { background: radial-gradient(120% 90% at 85% 0%, rgba(139,174,138,0.22), transparent 55%), linear-gradient(160deg, var(--forest-700) 0%, var(--forest-900) 70%); border-radius: var(--r-lg); padding: 36px; margin: 8px 0 48px; box-shadow: var(--shadow-3); }
  .sci-compare-label { font-family: var(--font-mono); font-size: 10px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.17em; color: rgba(139,174,138,0.8); margin-bottom: 26px; text-align: center; }
  .sci-compare-grid { display: grid; grid-template-columns: 1fr auto 1fr; gap: 22px; align-items: stretch; }
  .sci-cside { padding: 26px; border-radius: 16px; }
  .sci-cside.test { background: rgba(255,255,255,0.06); }
  .sci-cside.verdict { background: rgba(139,174,138,0.14); box-shadow: 0 14px 30px -14px rgba(0,0,0,0.4); }
  .sci-cside-tag { font-family: var(--font-mono); font-size: 9px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.17em; margin-bottom: 12px; }
  .sci-cside.test .sci-cside-tag { color: rgba(255,255,255,0.4); }
  .sci-cside.verdict .sci-cside-tag { color: #8BAE8A; }
  .sci-cside-title { font-family: var(--font-display); font-size: 24px; font-weight: 300; color: white; margin-bottom: 12px; line-height: 1.2; }
  .sci-cside-desc { font-size: 13px; line-height: 1.65; color: rgba(255,255,255,0.55); }
  .sci-cside.verdict .sci-cside-desc { color: rgba(255,255,255,0.72); }
  .sci-arrow { display: flex; align-items: center; justify-content: center; color: rgba(139,174,138,0.6); font-size: 24px; }
  .sci-disclaimers { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 16px; }
  .sci-answer { margin-top: 48px; background: radial-gradient(120% 90% at 15% 0%, rgba(139,174,138,0.2), transparent 55%), linear-gradient(200deg, var(--forest-700) 0%, var(--forest-900) 70%); border-radius: var(--r-lg); padding: 36px; box-shadow: var(--shadow-3); }
  .sci-answer-tag { font-family: var(--font-mono); font-size: 10px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.17em; color: rgba(139,174,138,0.8); margin-bottom: 12px; }
  .sci-answer-h { font-family: var(--font-display); font-size: 32px; font-weight: 300; color: white; margin-bottom: 14px; }
  .sci-answer-p { font-size: 15px; line-height: 1.7; color: rgba(255,255,255,0.72); max-width: 620px; }
  .sci-paths { margin-top: 40px; }
  .sci-paths-tag { font-family: var(--font-mono); font-size: 10px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.17em; color: var(--forest-500); margin-bottom: 10px; }
  .sci-paths-h { font-family: var(--font-display); font-size: 26px; font-weight: 400; color: var(--ink); margin-bottom: 22px; max-width: 560px; }
  .sci-paths-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
  .sci-path { background: var(--card-bg, var(--paper)); border-radius: var(--r-md); padding: 22px; box-shadow: var(--shadow-1); }
  .sci-path-num { width: 28px; height: 28px; border-radius: 50%; background: #EDF3ED; color: #3D5C3C; font-family: 'DM Mono', monospace; font-size: 13px; display: flex; align-items: center; justify-content: center; margin-bottom: 12px; }
  .sci-path-t { font-size: 15px; font-weight: 600; color: #1C1C1C; margin-bottom: 8px; }
  .sci-path-d { font-size: 13px; line-height: 1.6; color: #6A6A62; }
  @media (max-width: 760px) { .sci-paths-grid { grid-template-columns: 1fr; } }
  .sci-disc { display: flex; gap: 10px; align-items: flex-start; padding: 16px; background: var(--tint-warm); border-radius: var(--r-md); }
  .sci-disc-t { font-size: 12px; font-weight: 600; margin-bottom: 4px; }
  .sci-disc-d { font-size: 11.5px; color: #7A7A72; line-height: 1.55; }
  @media (max-width: 700px) {
    .sci-grid { grid-template-columns: 1fr; }
    .sci-compare-grid { grid-template-columns: 1fr; }
    .sci-arrow { transform: rotate(90deg); padding: 4px 0; }
    .sci-disclaimers { grid-template-columns: 1fr; }
  }

  .pricing-wrap { max-width: 460px; }
  .pricing-card { background: var(--card-bg, var(--paper)); border: none; border-radius: var(--r-lg); padding: 36px 32px; box-shadow: var(--shadow-2); }
  .price-tag { font-family: var(--font-mono); font-size: 10px; font-weight: 500; letter-spacing: 0.17em; text-transform: uppercase; color: var(--forest-500); margin-bottom: 12px; }
  .price-num { font-family: var(--font-display); font-size: 72px; font-weight: 300; line-height: 1; margin-bottom: 8px; letter-spacing: -0.02em; font-variant-numeric: lining-nums; }
  .price-sub { font-size: 13px; color: #73736A; margin-bottom: 24px; }
  .pricing-card .btn-p { padding: 17px 26px; font-size: 15px; border-radius: var(--r-pill); box-shadow: 0 14px 32px -6px rgba(61,92,60,0.55); }
  @media (hover: hover) { .pricing-card .btn-p:hover { box-shadow: 0 18px 38px -6px rgba(61,92,60,0.6); } }
  .price-div { height: 1px; background: rgba(56,62,48,0.08); margin: 24px 0; }
  .price-item { display: flex; align-items: flex-start; gap: 11px; margin-bottom: 12px; font-size: 13px; line-height: 1.5; }
  .p-check { width: 19px; height: 19px; background: #EDF3ED; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 1px; }
  .price-note { font-size: 12px; color: #7A7A72; margin-top: 16px; line-height: 1.65; padding-top: 16px; border-top: 1px solid rgba(0,0,0,0.07); }

  .faq-wrap { max-width: 660px; margin: 0 auto; }
  .faq-group { margin-bottom: 32px; }
  .faq-group:last-child { margin-bottom: 0; }
  .faq-group-label { font-family: var(--font-mono); font-size: 10px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.17em; color: var(--forest-500); margin-bottom: 14px; }
  .faq-list { display: flex; flex-direction: column; gap: 10px; }
  .faq-item { background: var(--card-bg, var(--paper)); border: none; border-radius: var(--r-md); cursor: pointer; padding: 0 20px; box-shadow: var(--shadow-1); transition: transform var(--t-fast) var(--ease), box-shadow var(--t-fast) var(--ease); }
  @media (hover: hover) { .faq-item:hover { transform: translateY(-1px); box-shadow: var(--shadow-2); } }
  .faq-item.open { box-shadow: var(--shadow-2); }
  .faq-q { font-size: 14.5px; font-weight: 500; display: flex; justify-content: space-between; align-items: center; gap: 16px; padding: 17px 0; line-height: 1.45; }
  .faq-a { font-size: 13.5px; color: #7A7A72; line-height: 1.75; padding: 0 0 18px; }
  .faq-plus { font-size: 20px; color: #3D5C3C; flex-shrink: 0; font-weight: 300; line-height: 1; width: 20px; text-align: center; }

  .cta-section { padding: 96px 64px; text-align: center; }
  .cta-section h2 { font-family: var(--font-display); font-size: 40px; font-weight: 300; margin-bottom: 14px; letter-spacing: -1px; line-height: 1.1; }
  .cta-section h2 em { font-style: italic; color: var(--forest-500); }
  .cta-section p { font-size: 14px; color: #73736A; margin-bottom: 30px; }
  .cta-section .btn-p { padding: 17px 32px; font-size: 15px; border-radius: var(--r-pill); }

  .mk-footer { padding: 40px 64px 48px; display: flex; align-items: center; justify-content: space-between; border-top: 1px solid rgba(56,62,48,0.08); background: transparent; }
  .mk-footer-logo { font-family: var(--font-display); font-size: 18px; font-weight: 500; color: var(--ink); }
  .mk-footer-note { font-size: 12px; color: #7A7A72; }
  .mk-footer-links { display: flex; gap: 20px; }
  .mk-footer-link { font-size: 12px; color: #7A7A72; cursor: pointer; }
  .mk-footer-link:hover { color: #1C1C1C; }

  .prob-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 14px; margin-bottom: 40px; }
  .prob-card { background: var(--card-bg, var(--paper)); border-radius: var(--r-md); padding: 22px 20px; box-shadow: var(--shadow-1); }
  .prob-t { font-family: var(--font-display); font-size: 18px; font-weight: 400; margin-bottom: 7px; }
  .prob-d { font-size: 12.5px; color: #73736A; line-height: 1.65; }

  /* ---- Scroll reveal (tiny IntersectionObserver adds .is-in) ---- */
  [data-reveal] { opacity: 0; transform: translateY(16px); transition: opacity 0.6s var(--ease), transform 0.6s var(--ease); }
  [data-reveal].is-in { opacity: 1; transform: translateY(0); }
  @media (prefers-reduced-motion: reduce) {
    [data-reveal] { opacity: 1; transform: none; transition: none; }
    .mk-hero.dark .mk-hero-centered::before, .mk-hero-orb1, .fmcard-orb { animation: none; }
    .mk-cta, .btn-p, .btn-g, .faq-item { transition: none; transform: none; }
  }

  /* ── MOBILE ─────────────────────────────────────────── */
  @media (max-width: 600px) {
    .mk-nav { padding: 0 16px; height: 54px; gap: 8px; }
    .mk-logo { font-size: 18px; flex-shrink: 0; }
    .mk-tabs { gap: 0; overflow-x: auto; -webkit-overflow-scrolling: touch; flex: 1; scrollbar-width: none; }
    .mk-tabs::-webkit-scrollbar { display: none; }
    .mk-tab { font-size: 12px; padding: 6px 8px; white-space: nowrap; flex-shrink: 0; }
    .mk-signin { padding: 6px 8px; font-size: 12px; flex-shrink: 0; }
    .mk-cta { padding: 8px 14px; font-size: 12px; flex-shrink: 0; }
    .mk-nav-right { gap: 4px; }
    .mk-hero { padding: 48px 22px 44px !important; }
    .mk-hero.dark { padding: 20px 14px 36px !important; }
    .mk-hero.dark .mk-hero-centered { padding: 52px 24px; }
    .price-num { font-size: 56px; }
    .mk-hero .mk-h1 { font-size: 36px !important; }
    .mk-h1 { font-size: 36px !important; letter-spacing: -0.5px; }
    .mk-sub { font-size: 15px; }
    .mk-section { padding: 44px 22px !important; }
    .sci-grid { grid-template-columns: 1fr; }
    .sci-disclaimers { grid-template-columns: 1fr; }
    .sci-compare-grid { grid-template-columns: 1fr; }
    .sci-arrow { transform: rotate(90deg); padding: 4px 0; }
    .sci-compare { padding: 24px; }
    .fmshow { grid-template-columns: 1fr; gap: 28px; }
    .prob-grid { grid-template-columns: 1fr; }
    .cta-section { padding: 56px 22px !important; }
    .cta-section h2 { font-size: 32px; }
    .mk-footer { padding: 28px 22px; flex-direction: column; gap: 14px; text-align: center; }
    .mk-actions { flex-direction: column; }
    .mk-actions.centered { flex-direction: column; }
    .btn-p, .btn-g { width: 100%; }
    .spine { padding-left: 36px; }
    .ph-name { font-size: 22px; }
    .sh { font-size: 26px !important; }
  }
  @media (max-width: 500px) {
    .mk-tabs { display: none; }
    .mk-menu-btn { display: inline-block; flex-shrink: 0; font-size: 12px; padding: 7px 11px; }
    .mk-nav-panel { display: flex; flex-direction: column; position: absolute; top: 100%; left: 0; right: 0; background: #FFFFFF; border-radius: 0 0 16px 16px; box-shadow: 0 24px 44px -12px rgba(56,62,48,0.25); padding: 6px 16px 10px; }
    .mk-menu-link { font-size: 14px; color: #20241F; background: none; border: none; border-bottom: 1px solid rgba(0,0,0,0.05); text-align: left; padding: 13px 4px; cursor: pointer; }
    .mk-menu-link:last-child { border-bottom: none; }
    .mk-menu-link.active { color: #3D5C3C; font-weight: 600; }
  }
  @media (max-width: 380px) {
    .mk-h1 { font-size: 31px !important; }
    .mk-tab { font-size: 11px; padding: 6px 5px; }
  }
`

const FAQ_GROUPS = [
  {
    group: 'Getting started',
    items: [
      { q: 'Do I need to already have a lab test?', a: 'No. A food sensitivity lab test is part of the program. You complete it from home, with no clinic visits, and once your results are in you upload them and they are read straight into your protocol. Already have recent results? You can use those instead.' },
      { q: "What's included in the price?", a: 'Everything: your lab test, the full elimination and reintroduction protocol, daily and weekly check-ins, pattern detection that learns your baseline, personalized insights, and your completed verdicts. One payment covers it all, there is no separate lab bill and nothing else to buy. Current pricing is on the Pricing page.' },
      { q: 'How much time does it take each week?', a: 'The daily check-in takes about 30 seconds. The weekly check-in takes about 2 minutes. During reintroduction cycles you spend a few extra minutes logging symptoms. It is built to fit into normal life.' },
    ],
  },
  {
    group: 'The program',
    items: [
      { q: 'What makes Sensify different from just buying a test?', a: 'A lab test gives you a list. Sensify runs each food through a controlled 14-day reintroduction cycle with daily tracking, so by the end you know for certain what your body does and does not tolerate. The test finds the suspects. Sensify confirms the truth.' },
      { q: 'How do the daily check-ins work?', a: 'Each day you log a quick snapshot: sleep, stress, hydration, whether you stayed on plan, and anything your body did that day. About 30 seconds. Every entry feeds a system that learns your patterns, cross-references your symptoms against your sleep and stress, and weighs all of it when your verdicts are decided.' },
      { q: 'Does Sensify actually analyze my data?', a: 'Yes, and it shows its work. Sensify learns your personal baseline during elimination, spots when a bad week lines up with bad sleep or high stress rather than food, and brings that context into every verdict, so a food never gets blamed for what your sleep did. No standalone lab test can do any of that.' },
      { q: "What if I don't see improvement during elimination?", a: 'Your symptom trends are monitored every week and flagged when improvement is not occurring. We look at compliance, hidden ingredients, and stress, and every flagged case is reviewed personally before any plan changes are suggested.' },
      { q: 'Do I have to finish the whole protocol?', a: 'The full value comes from completing the protocol, since the reintroduction phase is where your verdicts are earned. You can stop anytime, but your verdicts are only complete once each food has been tested. We designed the program to keep each step light so finishing feels doable.' },
      { q: 'What happens when I finish?', a: 'You receive your completed verdicts, yours to keep. You can also continue with Maintain, an optional monthly plan that keeps your verdicts working for you every day, with Ask Sensify on hand to check any food, menu, or meal against your results whenever you need it. Maintain pricing is on the Pricing page.' },
    ],
  },
  {
    group: 'Medical & safety',
    items: [
      { q: 'Is this a medical diagnosis?', a: 'No. Sensify is a wellness and educational program. It does not diagnose, treat, or cure any medical condition. If you have serious symptoms, always consult a licensed healthcare provider.' },
      { q: 'How accurate are IgG food sensitivity tests?', a: 'IgG tests measure immune reactivity, not confirmed intolerance. We treat your results as a starting hypothesis. The real evidence comes from the elimination and reintroduction protocol, which is why the protocol is the product, not the test.' },
      { q: 'What if it turns out food is not my problem?', a: 'That is a real and valuable answer, not a failure. Some people go through the protocol and find their body tolerates everything well. That means food sensitivity is unlikely to be driving what you feel, which saves you from years of cutting out foods for no reason and points you toward looking elsewhere. We would rather give you the honest truth than invent a problem that is not there. A clean result is still an answer you can trust and act on.' },
    ],
  },
]

function Faq() {
  const [open, setOpen] = useState('0-0')
  return (
    <div className="faq-wrap">
      {FAQ_GROUPS.map((grp, gi) => (
        <div key={gi} className="faq-group">
          <div className="faq-group-label">{grp.group}</div>
          <div className="faq-list">
            {grp.items.map((f, i) => {
              const key = `${gi}-${i}`
              const isOpen = open === key
              return (
                <div key={key} className={`faq-item${isOpen ? ' open' : ''}`} onClick={() => setOpen(isOpen ? null : key)}>
                  <div className="faq-q">{f.q}<span className="faq-plus">{isOpen ? '–' : '+'}</span></div>
                  {isOpen && <div className="faq-a">{f.a}</div>}
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  )
}

const Footer = () => (
  <div className="mk-footer">
    <div className="mk-footer-logo">Sensify<span className="mk-logo-dot">.</span></div>
    <div className="mk-footer-note">Wellness program only. Not medical advice.</div>
    <div className="mk-footer-links">
      <a className="mk-footer-link" href="/privacy.html" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>Privacy</a>
      <a className="mk-footer-link" href="/terms.html" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>Terms</a>
      <a className="mk-footer-link" href="mailto:alex@sensifyhealth.com" style={{ textDecoration: 'none' }}>Contact</a>
    </div>
  </div>
)

const CheckIcon = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#3D5C3C" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
)

const SHOWCASE_CAPTIONS = {
  'Dashboard': 'The day, the phase, the streak, your symptoms against baseline, and this week\u2019s insight. One glance and you\u2019re oriented.',
  'History': 'Every week on the record, measured against your own baseline.',
  'Reintro': 'Three days eating it, eleven days watching clean. Then the verdict.',
  'Verdicts': 'Safe. Limit. Avoid. Each one a card you earned, with the 14-day trial that proves it.',
  'Ask Sensify': 'Knows your map, your lab results, and where you are in testing. Ask anything.',
}

function ShowcaseScreen({ tab }) {
  const mono = "'DM Mono', monospace"
  const serif = "'Fraunces', serif"
  const TopBar = () => (
    <div style={{ textAlign: 'center', fontFamily: serif, fontSize: 13, color: '#1C1C1C', marginBottom: 11, paddingBottom: 9, borderBottom: '1px solid rgba(0,0,0,0.05)' }}>Sensify<span style={{ color: '#3D5C3C' }}>.</span></div>
  )
  if (tab === 'Dashboard') return (
    <>
      <TopBar />
      <div style={{ position: 'relative', background: '#22301F', borderRadius: 14, padding: '15px 14px', overflow: 'hidden', boxShadow: '0 12px 28px rgba(34,48,31,0.28)', marginBottom: 9 }}>
        <div style={{ position: 'absolute', top: -45, right: -45, width: 140, height: 140, borderRadius: '50%', background: '#8BAE8A', opacity: 0.1 }} />
        <div style={{ position: 'relative', fontFamily: mono, fontSize: 7.5, letterSpacing: '1.3px', color: '#C9A227', textTransform: 'uppercase', marginBottom: 7 }}>Elimination phase</div>
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <div>
            <div style={{ fontFamily: serif, fontSize: 32, fontWeight: 300, color: '#FAF8F4', lineHeight: 1 }}>42</div>
            <div style={{ fontSize: 9.5, color: 'rgba(250,248,244,0.55)' }}>of 56 days</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontFamily: serif, fontSize: 17, fontWeight: 300, color: '#8BAE8A', lineHeight: 1 }}>42</div>
            <div style={{ fontFamily: mono, fontSize: 7, color: 'rgba(250,248,244,0.45)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>day streak</div>
          </div>
        </div>
        <div style={{ position: 'relative', height: 4, background: 'rgba(255,255,255,0.1)', borderRadius: 3, margin: '9px 0 5px' }}><div style={{ width: '75%', height: 4, background: '#8BAE8A', borderRadius: 3 }} /></div>
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', fontSize: 7.5, color: 'rgba(250,248,244,0.45)' }}><span>Day 42</span><span>14 days to reintroduction</span></div>
      </div>
      <div style={{ background: '#FFFFFF', borderRadius: 16, boxShadow: '0 2px 10px rgba(56,62,48,0.09)', padding: 11, marginBottom: 9 }}>
        <div style={{ fontSize: 8.5, fontWeight: 600, color: '#1C1C1C', marginBottom: 6 }}>Currently avoiding <span style={{ fontWeight: 400, color: '#A8A69E' }}>· 8 foods</span></div>
        <div style={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
          {[['Gluten', '#C95B5B', '#FAEAEA'], ['Corn', '#C95B5B', '#FAEAEA'], ['Dairy', '#D4894A', '#FDF2EA'], ['Eggs', '#D4894A', '#FDF2EA'], ['Soy', '#3D5C3C', '#EDF3ED'], ['Almond', '#3D5C3C', '#EDF3ED']].map(([f, fg, bg]) => <span key={f} style={{ background: bg, color: fg, borderRadius: 12, padding: '3px 8px', fontSize: 8.5, fontWeight: 600 }}>{f}</span>)}
          <span style={{ background: '#F4F2EC', color: '#A8A69E', borderRadius: 12, padding: '3px 8px', fontSize: 8.5 }}>+ 2 more</span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
          <span style={{ fontSize: 6.5, color: '#C95B5B' }}>● High</span>
          <span style={{ fontSize: 6.5, color: '#D4894A' }}>● Moderate</span>
          <span style={{ fontSize: 6.5, color: '#3D5C3C' }}>● Low</span>
        </div>
      </div>
      <div style={{ background: '#FFFFFF', borderRadius: 16, boxShadow: '0 2px 10px rgba(56,62,48,0.09)', padding: 11, marginBottom: 9 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 6 }}>
          <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#2C9D8A' }} />
          <span style={{ fontFamily: mono, fontSize: 7, letterSpacing: '0.8px', color: '#3D5C3C', textTransform: 'uppercase' }}>Week 6 insight</span>
        </div>
        <div style={{ fontSize: 9.5, lineHeight: 1.65, color: '#1C1C1C' }}>Your bloating score has dropped for the third straight week, and your energy is holding above baseline. Six clean weeks is exactly the signal we need before testing begins.</div>
      </div>
      <div style={{ background: '#FFFFFF', borderRadius: 16, boxShadow: '0 2px 10px rgba(56,62,48,0.09)', padding: 11 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 7 }}>
          <span style={{ fontSize: 9, fontWeight: 600, color: '#1C1C1C' }}>Symptom trends</span>
          <div style={{ display: 'flex', gap: 3 }}>
            <span style={{ background: '#22301F', color: '#fff', borderRadius: 10, padding: '2px 7px', fontSize: 6.5 }}>Bloating</span>
            <span style={{ background: '#F4F2EC', color: '#8A8A82', borderRadius: 10, padding: '2px 7px', fontSize: 6.5 }}>Energy</span>
          </div>
        </div>
        <svg width="100%" height="56" viewBox="0 0 240 56">
          <line x1="0" y1="14" x2="240" y2="14" stroke="rgba(0,0,0,0.05)" strokeWidth="1" />
          <line x1="0" y1="32" x2="240" y2="32" stroke="rgba(0,0,0,0.05)" strokeWidth="1" />
          <line x1="0" y1="11" x2="240" y2="11" stroke="#D4894A" strokeWidth="1" strokeDasharray="3,3" opacity="0.5" />
          <path d="M 8 12 L 46 17 L 84 16 L 122 25 L 160 33 L 198 40 L 232 45" fill="none" stroke="#3D5C3C" strokeWidth="2" strokeLinecap="round" />
          <circle cx="232" cy="45" r="2.5" fill="#3D5C3C" />
        </svg>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 6.5, color: '#A8A69E', marginTop: 2 }}><span>Week 1</span><span style={{ color: '#D4894A' }}>- - baseline</span><span>Week 6</span></div>
        <div style={{ fontFamily: mono, fontSize: 7.5, color: '#3D5C3C', marginTop: 6 }}>-38% avg vs baseline</div>
      </div>
    </>
  )
  if (tab === 'History') return (
    <>
      <TopBar />
      <div style={{ background: '#FFFFFF', borderRadius: 16, boxShadow: '0 2px 10px rgba(56,62,48,0.09)', padding: '13px 13px', marginBottom: 9 }}>
        <div style={{ fontFamily: mono, fontSize: 7.5, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#7A7A72', marginBottom: 8 }}>Symptom progress</div>
        <div style={{ display: 'flex', gap: 3, background: '#F0EEE7', borderRadius: 8, padding: 3, marginBottom: 10 }}>
          <div style={{ flex: 1, textAlign: 'center', fontSize: 9.5, fontWeight: 600, color: '#1C1C1C', background: '#fff', padding: '4px 0', borderRadius: 6, boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>Overall average</div>
          <div style={{ flex: 1, textAlign: 'center', fontSize: 9.5, color: '#8A8A82', padding: '4px 0' }}>Latest week</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
          <div style={{ fontFamily: serif, fontSize: 26, fontWeight: 300, color: '#2C9D8A', lineHeight: 1 }}>-41%</div>
          <div style={{ fontSize: 9.5, color: '#7A7A72' }}>avg vs baseline</div>
        </div>
        <div style={{ fontSize: 8, color: '#A8A69E', marginBottom: 8 }}>across 9 weekly check-ins</div>
        {[['Bloating', 'avg 3.4 · down 51%', 34, 70, '#2C9D8A'], ['Reflux', 'avg 2.8 · down 44%', 28, 50, '#2C9D8A'], ['Energy', 'avg 6.9 · up 38%', 69, 50, '#5DBF8A']].map(([label, delta, w, tick, color]) => (
        <div key={label} style={{ marginBottom: 7 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 8.5, marginBottom: 3 }}><span style={{ color: '#4A4A45', fontWeight: 500 }}>{label}</span><span style={{ color }}>{delta}</span></div>
          <div style={{ position: 'relative', height: 6, background: '#F0EEE7', borderRadius: 4 }}><div style={{ width: `${w}%`, height: 6, background: color, borderRadius: 4 }} /><div style={{ position: 'absolute', left: `${tick}%`, top: -3, width: 2, height: 12, background: '#999', borderRadius: 1 }} /></div>
        </div>
        ))}
      </div>
      <div style={{ background: '#FFFFFF', borderRadius: 16, boxShadow: '0 2px 10px rgba(56,62,48,0.09)', padding: '13px 13px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <span style={{ fontFamily: serif, fontSize: 14, color: '#1C1C1C' }}>Week 9</span>
          <span style={{ display: 'inline-block', background: '#EDF3ED', color: '#3D5C3C', borderRadius: 12, padding: '2px 8px', fontSize: 8, fontWeight: 600 }}>Fully compliant</span>
        </div>
        <div style={{ display: 'flex', gap: 4, marginBottom: 8 }}>
          {[['Bloating', 3, '-57%'], ['Reflux', 2, '-60%'], ['Energy', 7, '+40%'], ['Sleep', 8, '+33%']].map(([l, v, d]) => (
            <div key={l} style={{ flex: 1, background: '#FAF8F4', borderRadius: 8, padding: '7px 3px', textAlign: 'center' }}>
              <div style={{ fontSize: 6.5, color: '#8A8A82' }}>{l}</div>
              <div style={{ fontFamily: serif, fontSize: 14, color: '#1C1C1C' }}>{v}</div>
              <div style={{ fontSize: 7, fontWeight: 500, color: '#4A8C6A' }}>{d}</div>
            </div>
          ))}
        </div>
        <div style={{ fontSize: 8, color: '#7A7A72', marginBottom: 8 }}>Context: normal week, nothing unusual flagged.</div>
        <div style={{ borderTop: '1px solid rgba(0,0,0,0.06)', paddingTop: 8 }}>
          <div style={{ fontFamily: mono, fontSize: 7, fontWeight: 500, letterSpacing: '0.12em', color: '#3D5C3C', textTransform: 'uppercase', marginBottom: 4 }}>Your week 9 insight</div>
          <div style={{ fontSize: 8.5, color: '#4A4A45', lineHeight: 1.6 }}>Nine weeks in and both of your main symptoms are holding well below baseline, even with eggs mid-test. That is a strong signal.</div>
        </div>
      </div>
    </>
  )
  if (tab === 'Reintro') return (
    <>
      <TopBar />
      <div style={{ position: 'relative', background: '#22301F', borderRadius: 14, padding: '15px 14px', overflow: 'hidden', boxShadow: '0 12px 30px rgba(34,48,31,0.28)', marginBottom: 9 }}>
        <div style={{ position: 'absolute', top: -40, right: -40, width: 130, height: 130, borderRadius: '50%', background: '#8BAE8A', opacity: 0.1 }} />
        <div style={{ position: 'relative', fontFamily: mono, fontSize: 7, letterSpacing: '1.2px', color: '#C9A227', textTransform: 'uppercase', marginBottom: 8 }}>Now testing</div>
        <div style={{ position: 'relative', fontFamily: serif, fontSize: 21, fontWeight: 300, color: '#FAF8F4', marginBottom: 2 }}>Eggs</div>
        <div style={{ position: 'relative', fontSize: 9.5, color: 'rgba(250,248,244,0.55)', marginBottom: 11 }}>Cycle day 4 of 14</div>
        <div style={{ position: 'relative', display: 'flex', gap: 2.5, marginBottom: 5 }}>
          {Array.from({ length: 14 }).map((_, i) => (
            <div key={i} style={{ flex: 1, height: 14, borderRadius: 3,
              background: i < 3 ? '#8BAE8A' : i === 13 ? 'rgba(201,162,39,0.35)' : i === 3 ? 'rgba(255,255,255,0.16)' : 'rgba(255,255,255,0.08)',
              border: i === 13 ? '1px solid #C9A227' : i === 3 ? '1px solid rgba(139,174,138,0.5)' : 'none' }} />
          ))}
        </div>
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', marginBottom: 9 }}>
          <span style={{ fontFamily: mono, fontSize: 6, letterSpacing: '0.5px', color: '#8BAE8A' }}>EAT IT · DAYS 1–3</span>
          <span style={{ fontFamily: mono, fontSize: 6, letterSpacing: '0.5px', color: 'rgba(250,248,244,0.45)' }}>WATCH · DAYS 4–13</span>
          <span style={{ fontFamily: mono, fontSize: 6, letterSpacing: '0.5px', color: '#C9A227' }}>VERDICT</span>
        </div>
        <div style={{ position: 'relative', background: 'rgba(255,255,255,0.06)', borderRadius: 9, padding: '9px 10px' }}>
          <div style={{ fontSize: 8.5, color: 'rgba(250,248,244,0.8)', lineHeight: 1.6 }}>You ate eggs for 3 days. Now 11 clean days while your daily check-ins watch for a reaction. Day 14, eggs get their verdict.</div>
        </div>
      </div>
      <div style={{ background: '#FFFFFF', borderRadius: 16, boxShadow: '0 2px 10px rgba(56,62,48,0.09)', padding: 13, marginBottom: 9 }}>
        <div style={{ fontSize: 9, fontWeight: 600, color: '#1C1C1C', marginBottom: 8 }}>Up next</div>
        {[['04', 'Almond'], ['05', 'Soy'], ['06', 'Tomato']].map(([n, f], i, arr) => (
          <div key={n} style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '6px 0', borderBottom: i < arr.length - 1 ? '1px solid rgba(0,0,0,0.04)' : 'none' }}>
            <span style={{ fontFamily: mono, fontSize: 8, color: '#C9C6BC', width: 13 }}>{n}</span>
            <span style={{ fontSize: 10.5, color: '#1C1C1C', fontWeight: 500 }}>{f}</span>
            <span style={{ marginLeft: 'auto', fontSize: 8, color: '#A0A096' }}>14-day cycle</span>
          </div>
        ))}
      </div>
      <div style={{ background: '#EDF3ED', borderRadius: 11, padding: '10px 12px' }}>
        <div style={{ fontSize: 8.5, color: '#3D5C3C', lineHeight: 1.55 }}><span style={{ fontWeight: 700 }}>3 verdicts earned so far</span> · Gluten, Wheat, and Oats are already ruled in your verdicts.</div>
      </div>
    </>
  )
  if (tab === 'Verdicts') return (
    <>
      <TopBar />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 12, padding: '0 2px' }}>
        <div>
          <div style={{ fontFamily: mono, fontSize: 5.5, letterSpacing: '1.6px', color: '#9A927E', marginBottom: 4 }}>SENSIFY · THE VERDICTS</div>
          <div style={{ fontFamily: serif, fontSize: 16, fontWeight: 400, color: '#1C1C1C', fontVariationSettings: "'SOFT' 60, 'WONK' 1" }}>Sarah's <span style={{ color: '#3D5C3C' }}>verdicts.</span></div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontFamily: serif, fontSize: 15, color: '#3D5C3C', lineHeight: 1 }}>4<span style={{ color: 'rgba(28,28,28,0.25)', fontSize: 11 }}> / 6</span></div>
          <div style={{ fontFamily: mono, fontSize: 4.5, letterSpacing: '1px', color: '#9A927E', marginTop: 2 }}>FOODS RULED</div>
        </div>
      </div>
      {(() => {
        const card = (name, word, sub, color, bg, bd, ghost, live) => (
          <div key={name} style={{ borderRadius: 12, padding: '12px 12px 11px', background: bg, border: `1px ${ghost ? 'dashed' : 'solid'} ${bd}`, minHeight: 74, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontFamily: mono, fontSize: 5.5, letterSpacing: '1.3px', color: ghost ? 'rgba(122,122,114,0.5)' : '#7A7A72' }}>{name}</div>
              <div style={{ fontFamily: serif, fontSize: ghost ? 13 : 19, color, lineHeight: 1, marginTop: 5, fontVariationSettings: "'SOFT' 60, 'WONK' 1", animation: live ? 'mkPulse 2s infinite' : 'none' }}>{word}</div>
            </div>
            {sub && <div style={{ fontSize: 7.5, color: ghost ? 'rgba(122,122,114,0.45)' : '#7A7A72', lineHeight: 1.45, marginTop: 8 }}>{sub}</div>}
          </div>
        )
        return (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            {card('DAIRY', 'On trial.', 'Day 2 of a 14 day test', '#2C9D8A', '#E7F3F0', 'rgba(44,157,138,0.22)', false, true)}
            {card('WHEAT', 'Safe.', 'No reaction across 14 days', '#3D5C3C', '#EDF3ED', 'rgba(61,92,60,0.14)')}
            {card('OATS', 'Safe.', 'No reaction across 14 days', '#3D5C3C', '#EDF3ED', 'rgba(61,92,60,0.14)')}
            {card('COFFEE', 'Limit.', 'Mild reaction at full servings', '#C07A28', '#FBF3E4', 'rgba(192,122,40,0.16)')}
            {card('GLUTEN', 'Avoid.', 'Reacted on 2 of 3 test days', '#C0392B', '#F9EAE8', 'rgba(192,57,43,0.14)')}
            {card('SOY', 'Up next.', 'Tested after dairy', 'rgba(28,28,28,0.25)', 'transparent', 'rgba(0,0,0,0.13)', true)}
          </div>
        )
      })()}
      <div style={{ marginTop: 12, padding: '0 2px', fontSize: 8, color: '#9A927E', lineHeight: 1.5, textAlign: 'center' }}>Every verdict comes from testing the food on your own body. Nothing is assumed.</div>
    </>
  )
  return (
    <>
      <TopBar />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 9 }}>
        <div style={{ background: '#3D5C3C', color: '#fff', borderRadius: '14px 14px 4px 14px', padding: '9px 12px', fontSize: 10.5, lineHeight: 1.5, maxWidth: '85%' }}>Going to an Italian restaurant tonight. What can I actually order?</div>
      </div>
      <div style={{ marginBottom: 9 }}>
        <div style={{ background: '#FFFFFF', borderRadius: '14px 14px 14px 4px', boxShadow: '0 2px 10px rgba(56,62,48,0.09)', padding: '11px 12px', maxWidth: '94%' }}>
          <div style={{ fontFamily: mono, fontSize: 7, letterSpacing: '0.8px', color: '#3D5C3C', textTransform: 'uppercase', marginBottom: 5 }}>Based on your elimination list</div>
          <div style={{ fontSize: 10.5, color: '#1C1C1C', lineHeight: 1.6, marginBottom: 8 }}>Plenty, even with gluten and chicken both out. Here's the play:</div>
          {[['SAFE TO ORDER', '#3D5C3C', 'Grilled branzino or steak, caprese salad, risotto, polenta dishes'], ['SKIP', '#C95B5B', 'Pasta, the bread basket, anything breaded, and the chicken dishes'], ['ASK THE KITCHEN', '#C9A227', 'Whether they have gluten-free pasta, and if any sauces are thickened with flour']].map(([label, color, text], i) => (
            <div key={label} style={{ background: '#FAF8F4', borderRadius: 9, padding: '8px 10px', marginBottom: i < 2 ? 5 : 0 }}>
              <div style={{ fontSize: 8, fontWeight: 700, color, marginBottom: 3 }}>{label}</div>
              <div style={{ fontSize: 9.5, color: '#4A4A45', lineHeight: 1.55 }}>{text}</div>
            </div>
          ))}
          <div style={{ fontSize: 9.5, color: '#4A4A45', lineHeight: 1.55, marginTop: 8 }}>If you want pasta specifically, most spots will do gluten-free penne with pomodoro or arrabbiata, both clean for your list.</div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center', background: '#FFFFFF', borderRadius: 16, boxShadow: '0 2px 10px rgba(56,62,48,0.09)', padding: '6px 6px 6px 12px' }}>
        <div style={{ flex: 1, fontSize: 10, color: '#A8A69E' }}>Ask about any food or menu</div>
        <div style={{ background: '#3D5C3C', color: '#fff', width: 28, height: 28, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12 }}>↑</div>
      </div>
    </>
  )
}

export default function Marketing({ onGetStarted, onSignIn }) {
  const [tab, setTab] = useState('home')
  const [menuOpen, setMenuOpen] = useState(false)
  const [homeFaq, setHomeFaq] = useState(null)

  const tabs = ['home', 'how', 'science', 'pricing', 'faq', 'about']
  const tabLabel = t => t === 'home' ? 'Home' : t === 'how' ? 'How it works' : t === 'faq' ? 'FAQ' : t.charAt(0).toUpperCase() + t.slice(1)

  const Nav = () => (
    <nav className="mk-nav">
      <div className="mk-logo">Sensify<span className="mk-logo-dot">.</span></div>
      <div className="mk-tabs">
        {tabs.map(t => (
          <button key={t} className={`mk-tab${tab === t ? ' active' : ''}`} onClick={() => setTab(t)}>
            {tabLabel(t)}
          </button>
        ))}
      </div>
      <div className="mk-nav-right">
        <button className="mk-menu-btn" aria-expanded={menuOpen} onClick={() => setMenuOpen(o => !o)}>{menuOpen ? 'Close' : 'Menu'}</button>
        <button className="mk-signin" onClick={onSignIn}>Sign in</button>
        <button className="mk-cta" onClick={onGetStarted}>Get started</button>
      </div>
      {menuOpen && (
        <div className="mk-nav-panel">
          {tabs.map(t => (
            <button key={t} className={`mk-menu-link${tab === t ? ' active' : ''}`} onClick={() => { setTab(t); setMenuOpen(false) }}>
              {tabLabel(t)}
            </button>
          ))}
        </div>
      )}
    </nav>
  )

  const [showcaseTab, setShowcaseTab] = useState('Dashboard')
  React.useEffect(() => { window.scrollTo(0, 0) }, [tab])

  // Presentation only: sections carrying data-reveal rise in as they enter the viewport.
  React.useEffect(() => {
    const els = Array.from(document.querySelectorAll('[data-reveal]'))
    if (els.length === 0) return undefined
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduce || typeof IntersectionObserver === 'undefined') {
      els.forEach(el => el.classList.add('is-in'))
      return undefined
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target) }
      })
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' })
    els.forEach(el => io.observe(el))
    return () => io.disconnect()
  }, [tab])

  if (tab === 'home') return (
    <div className="mk-page">
      <style>{css}</style>
      <Nav />
      <div className="mk-hero dark">
        <div className="mk-hero-centered" style={{ position: 'relative' }}>
          <div className="mk-hero-orb1"></div>
          <div className="mk-hero-orb2"></div>
          <div className="mk-hero-eyebrow sn-rise" style={{ position: 'relative' }}>Test. Eliminate. Reintroduce. Know.</div>
          <div className="mk-h1 centered sn-rise-2" style={{ position: 'relative' }}>Stop guessing what your body <em>can't handle.</em></div>
          <div className="mk-sub centered sn-rise-3" style={{ position: 'relative' }}>A lab test finds the suspects. Eight weeks of clean baseline, then a 14-day trial of every food, gives the verdicts.</div>
          <div className="mk-actions centered sn-rise-4" style={{ position: 'relative' }}>
            <button className="btn-p" onClick={onGetStarted} style={{ background: '#8BAE8A', color: '#22301F', boxShadow: '0 10px 24px -6px rgba(0,0,0,0.35)' }}>Start your program</button>
            <button className="btn-g" onClick={() => setTab('how')}>See how it works</button>
          </div>
          <div className="mk-price-line sn-rise-4" style={{ position: 'relative' }}>$399 · lab test included · one payment</div>
          <div className="sn-rise-4" style={{ position: 'relative', fontSize: '11.5px', color: 'rgba(250,248,244,0.38)', marginTop: '7px', lineHeight: 1.6, maxWidth: 520, marginLeft: 'auto', marginRight: 'auto' }}>Lab test, elimination protocol, daily and weekly check-ins, personalized insights, guided reintroductions, Ask Sensify, and your final verdicts.</div>
        </div>
      </div>

      {/* The Verdicts — its own showcase section */}
      <div className="mk-section cream" data-reveal>
        <div className="mk-section-inner">
          <div className="ey">The problem</div>
          <div className="sh">Most people suspect food.<br />Almost none ever confirm it.</div>
          <div className="ss">Food sensitivity tests are more accessible than ever. But buying a test is easy. Knowing what to do with it isn't. Without a structured process, most people eliminate a few things, feel slightly better, give up, and never get real answers.</div>
          <div className="prob-grid">
            <div className="prob-card"><div className="prob-t">Tests are easy to buy</div><div className="prob-d">But most people who buy a food sensitivity test never follow a proper elimination protocol.</div></div>
            <div className="prob-card"><div className="prob-t">Guessing doesn't work</div><div className="prob-d">Randomly cutting foods with no structure gives you no signal. You don't know what's helping.</div></div>
            <div className="prob-card"><div className="prob-t">No accountability</div><div className="prob-d">No daily check-ins, no AI tracking your symptoms, no verdicts at the end. Just a list and good luck.</div></div>
          </div>
        </div>
      </div>

      <div className="mk-section alt" data-reveal>
        <div className="mk-section-inner">
          <div className="ey">How it works</div>
          <div className="sh">Four steps to certainty.</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: '14px', marginTop: '28px' }}>
            {[
              { n: '01', t: 'Test', d: 'Complete your intake and at-home lab test. Your results become the starting hypothesis: the suspects, not the verdict.' },
              { n: '02', t: 'Eliminate', d: 'Eight weeks without your target foods, with 30-second daily check-ins. Your symptoms settle into a clean baseline.' },
              { n: '03', t: 'Reintroduce', d: 'Each food returns one at a time in a controlled cycle while we track your response. Your body gives the real answer.' },
              { n: '04', t: 'Know', d: 'Every food lands where it belongs: Safe, Limit, or Avoid. Every verdict is earned and yours to keep.' },
            ].map((s, i) => (
              <div key={i} className="sn-card-hov" style={{ background: 'var(--card-bg, #FFFFFF)', borderRadius: 16, padding: '22px 20px', boxShadow: 'var(--shadow-1)' }}>
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', fontWeight: 500, color: '#8BAE8A', letterSpacing: '0.17em', marginBottom: '10px' }}>{s.n}</div>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: '20px', color: '#20241F', marginBottom: '8px' }}>{s.t}</div>
                <div style={{ fontSize: '12.5px', color: '#7A7A72', lineHeight: 1.65 }}>{s.d}</div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: '22px' }}>
            <button className="btn-g" onClick={() => setTab('how')}>See the full program &rarr;</button>
          </div>
        </div>
      </div>

      {/* ===== INSIDE THE PROGRAM — tabbed product showcase (Format B) ===== */}
      <div className="mk-section cream" data-reveal>
        <div className="mk-section-inner" style={{ textAlign: 'center' }}>
          <div className="ey">Inside the program</div>
          <div className="sh">A look at what you're getting.</div>
          <div style={{ fontSize: '14px', color: '#73736A', lineHeight: 1.65, maxWidth: 520, margin: '10px auto 18px' }}>Thirty seconds a day. One real check-in a week. And every so often, a verdict you earned.</div>
          <div style={{ fontSize: '12px', color: '#A8A69E', marginBottom: '14px' }}>Tap through the screens below.</div>

          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: 26, flexWrap: 'wrap' }}>
            {['Dashboard', 'History', 'Reintro', 'Verdicts', 'Ask Sensify'].map(t => (
              <button key={t} onClick={() => setShowcaseTab(t)} className={showcaseTab === t ? 'sn-chip sn-chip-on' : 'sn-chip'}>{t}</button>
            ))}
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: 310 }}>
              <div style={{ background: '#20241F', borderRadius: 28, padding: 8, boxShadow: 'var(--shadow-3)' }}>
                <div key={showcaseTab} style={{ background: '#F7F5EF', borderRadius: 20, padding: '15px 13px', height: 560, overflow: 'hidden', textAlign: 'left', animation: 'mkFade 0.25s ease' }}>
                  <ShowcaseScreen tab={showcaseTab} />
                </div>
              </div>
              <div style={{ marginTop: 14, minHeight: 40 }}>
                <div style={{ fontSize: 13, color: '#7A7A72', lineHeight: 1.6, maxWidth: 290, margin: '0 auto' }}>{SHOWCASE_CAPTIONS[showcaseTab]}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mk-section alt" data-reveal>
        <div className="mk-section-inner">
          <div className="fmshow">
            <div className="fmshow-copy">
              <div className="ey">The outcome</div>
              <div className="sh" style={{ marginBottom: '18px' }}>Verdicts that are actually earned.</div>
              <div className="ss" style={{ marginBottom: '22px' }}>No food gets labeled Safe without being tested. No food gets labeled Avoid without structured evidence. Everything you eat, sorted into three honest categories by your own body, and yours to keep.</div>
              <div>
                {[
                  ['Safe', 'Tested, tolerated, eat freely.', '#137663', 'rgba(44,157,138,0.09)', 'rgba(44,157,138,0.4)', 'rgba(44,157,138,0.25)'],
                  ['Limit', 'Fine in small amounts.', '#9A5E0B', 'rgba(232,148,31,0.09)', 'rgba(232,148,31,0.42)', 'rgba(232,148,31,0.24)'],
                  ['Avoid', 'A confirmed trigger.', '#B03434', 'rgba(214,69,69,0.08)', 'rgba(214,69,69,0.4)', 'rgba(214,69,69,0.22)'],
                ].map(([name, desc, fg, bg, bd, glow]) => (
                  <div key={name} style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '12px 0' }}>
                    <span style={{ background: bg, color: fg, border: `1px solid ${bd}`, boxShadow: `0 0 16px ${glow}`, borderRadius: 20, padding: '8px 18px', fontSize: 14, fontWeight: 700, flexShrink: 0, minWidth: 64, textAlign: 'center' }}>{name}</span>
                    <span style={{ fontSize: 13.5, color: '#5A5A52', lineHeight: 1.5 }}>{desc}</span>
                  </div>
                ))}
              </div>
              <div style={{ fontSize: '13px', color: '#7A7A72', lineHeight: 1.7, marginTop: '18px', paddingTop: '16px', borderTop: '1px solid rgba(0,0,0,0.07)' }}>And sometimes the answer is that food was never the problem. That is a real result too, and knowing it saves you from years of cutting things out for nothing.</div>
            </div>
            <div className="fmcard">
              <div className="fmcard-orb" />
              <div className="fmcard-orb2" />
              <div className="fmcard-eyebrow" style={{ position: 'relative' }}>Example · A finished program</div>
              <div className="fmcard-title">A finished <span style={{ color: '#8BAE8A' }}>map.</span></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 7, marginBottom: 16, position: 'relative' }}>
                {[
                  ['WHEAT', 'Safe.', '#5FD4BC', 'rgba(44,157,138,0.12)', 'rgba(44,157,138,0.3)'],
                  ['OATS', 'Safe.', '#5FD4BC', 'rgba(44,157,138,0.12)', 'rgba(44,157,138,0.3)'],
                  ['COFFEE', 'Limit.', '#F2C078', 'rgba(232,148,31,0.12)', 'rgba(232,148,31,0.35)'],
                  ['SOY', 'Limit.', '#F2C078', 'rgba(232,148,31,0.12)', 'rgba(232,148,31,0.35)'],
                  ['GLUTEN', 'Avoid.', '#F2A0A0', 'rgba(214,69,69,0.12)', 'rgba(214,69,69,0.35)'],
                  ['DAIRY', 'Avoid.', '#F2A0A0', 'rgba(214,69,69,0.12)', 'rgba(214,69,69,0.35)'],
                ].map(([nm, wd, fg, bg, bd]) => (
                  <div key={nm} style={{ background: bg, border: `1px solid ${bd}`, borderRadius: 10, padding: '9px 10px' }}>
                    <div style={{ fontFamily: 'DM Mono, monospace', fontSize: 6, letterSpacing: '1.2px', color: 'rgba(250,248,244,0.5)' }}>{nm}</div>
                    <div style={{ fontFamily: 'Fraunces, serif', fontSize: 15, color: fg, marginTop: 3, lineHeight: 1, fontVariationSettings: "'SOFT' 60, 'WONK' 1" }}>{wd}</div>
                  </div>
                ))}
              </div>
              <div className="fmcard-foot">
                <div className="fmcard-verify" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>EXAMPLE · WHAT 140 DAYS OF TESTING PRODUCES</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mk-section cream" data-reveal>
        <div className="mk-section-inner">
          <div className="ey">Before you start</div>
          <div className="sh">The questions everyone asks.</div>
          <div className="faq-list" style={{ maxWidth: '660px', marginTop: '26px' }}>
            {[
              { q: "What's included in the price?", a: 'Everything: your lab test, the full elimination and reintroduction protocol, daily and weekly check-ins, pattern detection that learns your baseline, personalized insights, and your completed verdicts. One payment covers it all, there is no separate lab bill and nothing else to buy. Current pricing is on the Pricing page.' },
              { q: 'What makes Sensify different from just buying a test?', a: 'A lab test gives you a list. Sensify runs each food through a controlled 14-day reintroduction cycle with daily tracking, so by the end you know for certain what your body does and does not tolerate. The test finds the suspects. Sensify confirms the truth.' },
              { q: 'How much time does it take each week?', a: 'The daily check-in takes about 30 seconds. The weekly check-in takes about 2 minutes. During reintroduction cycles you spend a few extra minutes logging symptoms. It is built to fit into normal life.' },
              { q: 'What if it turns out food is not my problem?', a: 'That is a real and valuable answer, not a failure. Some people finish the protocol and find their body tolerates everything well, which saves you from years of cutting out foods for no reason and points you toward looking elsewhere. A clean result is still an answer you can trust.' },
              { q: 'Do I need to already have a lab test?', a: 'No. A food sensitivity lab test is part of the program. You complete it from home, no clinic visits, then upload your results and they are read straight into your protocol. Already have recent results? You can use those instead.' },
            ].map((f, i) => {
              const isOpen = homeFaq === i
              return (
                <div key={i} className={`faq-item${isOpen ? ' open' : ''}`} onClick={() => setHomeFaq(isOpen ? null : i)}>
                  <div className="faq-q">{f.q}<span className="faq-plus">{isOpen ? '−' : '+'}</span></div>
                  {isOpen && <div className="faq-a">{f.a}</div>}
                </div>
              )
            })}
          </div>
          <div style={{ marginTop: '18px' }}>
            <button className="btn-g" onClick={() => setTab('faq')}>Read all FAQs &rarr;</button>
          </div>
        </div>
      </div>

      <div className="cta-section" data-reveal>
        <h2>Stop guessing.<br />Start knowing.</h2>
        <p>A lab test alone costs $150 to $300 and hands you a guess. Sensify includes the lab <em style={{ fontStyle: 'normal', fontWeight: 600 }}>and</em> the months of structure that turn it into an answer. One price, nothing else to buy.</p>
        <button className="btn-p" onClick={onGetStarted}>Start your program</button>
        <div style={{ maxWidth: '480px', margin: '44px auto 0', paddingTop: '28px', borderTop: '1px solid rgba(0,0,0,0.07)', textAlign: 'left' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', fontWeight: 500, letterSpacing: '0.17em', color: '#3D5C3C', textTransform: 'uppercase', marginBottom: '10px' }}>A note from the founder</div>
          <div style={{ fontSize: '13.5px', color: '#4A4A45', lineHeight: 1.75 }}>I built Sensify alone, after years of guessing at my own symptoms and getting nowhere. Every screen in the product shows you the evidence behind every verdict, because that is the standard I wanted for myself. And if the program turns out not to be for you, write to me and we will make it right.</div>
          <a href="mailto:alex@sensifyhealth.com" style={{ display: 'inline-block', marginTop: '12px', fontSize: '12.5px', color: '#3D5C3C', textDecoration: 'underline', textUnderlineOffset: '3px' }}>alex@sensifyhealth.com</a>
        </div>
      </div>
      <Footer />
    </div>
  )

  if (tab === 'how') return (
    <div className="mk-page">
      <style>{css}</style>
      <Nav />
      <div className="mk-hero" style={{ padding: '56px 64px 12px' }}>
        <div className="mk-hero-inner sn-rise">
          <div className="mk-tag">The complete program</div>
          <div className="mk-h1" style={{ fontSize: '46px' }}>How Sensify works.</div>
          <div className="mk-sub" style={{ marginBottom: 0 }}>A structured system that takes you from suspecting a food trigger to having your verdicts: a personal, evidence-based ruling on every tested food.</div>
        </div>
      </div>

      {/* PHASE 1 — SETUP */}
      <div className="mk-section alt" data-reveal>
        <div className="mk-section-inner">
          <div className="ph-head">
            <span className="ph-badge">SETUP</span>
            <div><div className="ph-name">Before the protocol begins.</div><div className="ph-time">One time</div></div>
          </div>
          <div className="spine">
            <div className="spine-step">
              <div className="spine-dot"></div>
              <div className="spine-tag">Step 1</div>
              <div className="spine-title">Complete your intake survey</div>
              <div className="spine-desc">Tell us about your symptoms and rate your baseline severity on a 1 to 10 scale. This becomes the comparison point for every improvement throughout your program. You also tell us how often you eat common foods, so we know your habits before your lab results even arrive.</div>
            </div>
            <div className="spine-step">
              <div className="spine-dot"></div>
              <div className="spine-tag">Step 2</div>
              <div className="spine-title">Complete your lab test from home</div>
              <div className="spine-desc">Your lab test is part of the $399, so there is no separate lab bill. You complete it from home, with no clinic visits, and if you already have recent results you can use those instead.</div>
            </div>
            <div className="spine-step">
              <div className="spine-dot"></div>
              <div className="spine-tag">Step 3</div>
              <div className="spine-title">Upload your results, read in seconds</div>
              <div className="spine-desc">Upload your lab PDF, take a photo, or enter results manually. Every flagged food is extracted and categorized as High, Moderate, or Low sensitivity, then cross-referenced with your eating habits to build your elimination list. You review and confirm before anything starts.</div>
            </div>
          </div>
        </div>
      </div>

      {/* PHASE 2 — ELIMINATION */}
      <div className="mk-section" data-reveal>
        <div className="mk-section-inner">
          <div className="ph-head">
            <span className="ph-badge">ELIMINATION</span>
            <div><div className="ph-name">Eight weeks of clean signal.</div><div className="ph-time">Months 1–2</div></div>
          </div>
          <div className="spine">
            <div className="spine-step">
              <div className="spine-dot"></div>
              <div className="spine-tag">Daily</div>
              <div className="spine-title">Daily check-in, about 30 seconds</div>
              <div className="spine-desc">Each day you log sleep, stress, hydration, whether you stayed on plan, and anything your body did. Staying on plan builds your streak, and an honest slip never counts against you. Every entry feeds a system that is learning your patterns.</div>
            </div>
            <div className="spine-step">
              <div className="spine-dot"></div>
              <div className="spine-tag">Weekly</div>
              <div className="spine-title">Weekly symptom check-in</div>
              <div className="spine-desc">Every 7 days a check-in appears on your dashboard. Takes about 2 minutes. Rate your symptoms on a 1 to 10 scale, with questions personalized to your intake. Submit and a personalized insight is generated from your symptom trend, compliance, and baseline, and it sharpens every week.</div>
            </div>
            <div className="spine-step">
              <div className="spine-dot"></div>
              <div className="spine-tag">Always on</div>
              <div className="spine-title">Sensify learns you</div>
              <div className="spine-desc">Behind the check-ins, a pattern engine is building your personal baseline: how often symptoms show up on clean weeks, how your sleep and stress move with how you feel. By week 4 it starts cross-referencing, and everything it learns is weighed when your verdicts are decided, so a food never gets blamed for what your sleep did.</div>
            </div>
            <div className="spine-step">
              <div className="spine-dot"></div>
              <div className="spine-tag amber">If needed</div>
              <div className="spine-title">Compliance support, if you hit a wall</div>
              <div className="spine-desc">If staying on plan gets hard, you tell us what's toughest, cravings, social situations, hidden ingredients, cost, and the app responds with specific guidance for your situation. Every case is reviewed personally, by the founder, before any plan recommendation is made.</div>
            </div>
          </div>
        </div>
      </div>

      {/* PHASE 3 — REINTRODUCTION */}
      <div className="mk-section alt" data-reveal>
        <div className="mk-section-inner">
          <div className="ph-head">
            <span className="ph-badge">REINTRODUCTION</span>
            <div><div className="ph-name">Where you get your answers.</div><div className="ph-time">Months 2–6</div></div>
          </div>
          <div className="spine">
            <div className="spine-step">
              <div className="spine-dot"></div>
              <div className="spine-tag">Ordered</div>
              <div className="spine-title">Your testing order is decided, not random</div>
              <div className="spine-desc">The foods you eat most often are tested first, because they matter most to your daily life. Among equals, your strongest lab suspects go ahead. You can always override the order and pick any food yourself.</div>
            </div>
            <div className="spine-step">
              <div className="spine-dot"></div>
              <div className="spine-tag">14 days each</div>
              <div className="spine-title">Each food gets a structured 14-day cycle</div>
              <div className="spine-desc">Three days eating the food as you normally would, then eleven days off to let symptoms settle. This exposure-washout pattern is modeled on the clinical elimination-diet standard for isolating how a single food affects you.</div>
              <div className="cyclebox">
                <div className="cb-label">One 14-day cycle</div>
                <div className="cb-dots">
                  {[...Array(14)].map((_, i) => (
                    <div key={i} className="cb-dot" style={{ background: i < 3 ? '#8BAE8A' : 'rgba(250,248,244,0.22)', boxShadow: i < 3 ? '0 0 10px rgba(139,174,138,0.6)' : 'none', marginRight: i === 2 ? '6px' : undefined }}></div>
                  ))}
                </div>
                <div className="cb-labels"><span style={{ flex: 3 }}>Exposure (days 1–3)</span><span style={{ flex: 11, textAlign: 'right' }}>Washout (days 4–14)</span></div>
              </div>
            </div>
            <div className="spine-step">
              <div className="spine-dot"></div>
              <div className="spine-tag">Day 14</div>
              <div className="spine-title">Get your verdict</div>
              <div className="spine-desc">Your daily logs across the cycle produce a verdict: Safe, Limit, or Avoid. Each one is entered in your verdicts. No food gets labeled without real evidence from your own body.</div>
            </div>
            <div className="spine-step">
              <div className="spine-dot"></div>
              <div className="spine-tag">End of program</div>
              <div className="spine-title">Receive your verdicts</div>
              <div className="spine-desc">By the end, every tested food is categorized by real symptom evidence. Safe, Limit, Avoid, all earned. Your verdicts are personal and yours to keep. You can continue with Maintain, which keeps your verdicts working for you every day with Ask Sensify always on hand.</div>
            </div>
          </div>
        </div>
      </div>

      <div className="cta-section" data-reveal>
        <h2>Ready to start?</h2>
        <p>The complete system is $399, lab test included. Nothing else to buy.</p>
        <button className="btn-p" onClick={onGetStarted}>Get started today</button>
      </div>
      <Footer />
    </div>
  )

  if (tab === 'science') return (
    <div className="mk-page">
      <style>{css}</style>
      <Nav />
      <div className="mk-hero" style={{ padding: '56px 64px 12px' }}>
        <div className="mk-hero-inner sn-rise">
          <div className="mk-tag">The science</div>
          <div className="mk-h1" style={{ fontSize: '46px' }}>Your lab test is a hypothesis.<br />Your body gives the verdict.</div>
          <div className="mk-sub" style={{ marginBottom: 0 }}>IgG tests measure exposure, not reaction. A high reading for eggs might just mean you eat eggs every day. Sensify confirms what's real by testing it in your actual life.</div>
        </div>
      </div>
      <div className="mk-section alt" data-reveal>
        <div className="mk-section-inner">
          {/* Hypothesis vs verdict centerpiece */}
          <div className="sci-compare">
            <div className="sci-compare-label">The difference that matters</div>
            <div className="sci-compare-grid">
              <div className="sci-cside test">
                <div className="sci-cside-tag">The lab test</div>
                <div className="sci-cside-title">A hypothesis</div>
                <div className="sci-cside-desc">Measures how much your immune system has been exposed to a food. Flags what's worth investigating. It cannot tell you what's actually causing your symptoms.</div>
              </div>
              <div className="sci-arrow">→</div>
              <div className="sci-cside verdict">
                <div className="sci-cside-tag">Sensify</div>
                <div className="sci-cside-title">A verdict</div>
                <div className="sci-cside-desc">Removes and reintroduces each flagged food in real life, tracks your response daily, and confirms the truth: Safe, Limit, or Avoid.</div>
              </div>
            </div>
          </div>

          <div className="ey">Why the method works</div>
          <div className="sh" style={{ fontSize: '28px', marginBottom: '8px' }}>Built on the method clinicians actually use.</div>
          <div className="sci-grid" style={{ marginTop: '24px' }}>
            {[
              { title: 'Elimination & reintroduction', desc: 'The standard clinical approach for identifying food triggers, used by gastroenterologists and dietitians to separate real reactions from suspicion.', badge: null },
              { title: '14-day reintroduction cycles', desc: 'Each food is reintroduced for 3 days then removed for 11. This exposure-washout pattern isolates symptom responses with enough signal to draw reliable conclusions.', badge: null },
              { title: 'Daily compliance tracking', desc: 'Daily check-ins give seven data points per week instead of one. That resolution makes it possible to spot patterns, like symptoms spiking the day after a slip-up, that weekly surveys miss entirely.', badge: null },
              { title: 'Built on the clinical standard', desc: 'Our elimination timelines and reintroduction structure follow the clinical elimination diet method: the same structured approach dietitians have used for decades.', badge: 'Established method' },
            ].map((item, i) => (
              <div key={i} className="sci-card">
                <div className="sci-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3D5C3C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    {i === 0 && <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>}
                    {i === 1 && <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>}
                    {i === 2 && <><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></>}
                    {i === 3 && <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></>}
                  </svg>
                </div>
                <div className="sci-t">{item.title}</div>
                <div className="sci-d">{item.desc}</div>
                {item.badge && <div className="sci-badge">{item.badge}</div>}
              </div>
            ))}
          </div>

          {/* An answer either way */}
          <div className="sci-answer">
            <div className="sci-answer-tag">What you walk away with</div>
            <div className="sci-answer-h">An answer either way.</div>
            <div className="sci-answer-p">Most people who suspect food never get certainty. They cut things out, feel unsure, and second-guess forever. The protocol ends that. If a food is a trigger, you will know. And if your body turns out to tolerate everything well, you will know that too, with the same confidence. That is not a disappointing result. It means food is not the thing holding you back, which saves you years of needless restriction and tells you where to look instead. We will never invent a problem to justify the program. The honest answer is the whole point.</div>
          </div>

          {/* What happens based on your results — honest path for every outcome */}
          <div className="sci-paths">
            <div className="sci-paths-tag">A path for every result</div>
            <div className="sci-paths-h">Whatever your results show, you're not left guessing.</div>
            <div className="sci-paths-grid">
              <div className="sci-path">
                <div className="sci-path-num">1</div>
                <div className="sci-path-t">Your lab flags foods</div>
                <div className="sci-path-d">We build your protocol around the specific foods your panel flagged, testing each one through elimination and reintroduction to confirm which actually affect you.</div>
              </div>
              <div className="sci-path">
                <div className="sci-path-num">2</div>
                <div className="sci-path-t">Clean panel, real symptoms</div>
                <div className="sci-path-d">A clean panel doesn't mean nothing's wrong. Many real triggers, especially digestive ones, never show up on a lab. So we test the most common culprits directly, and you choose how thorough to go.</div>
              </div>
              <div className="sci-path">
                <div className="sci-path-num">3</div>
                <div className="sci-path-t">Food isn't the issue</div>
                <div className="sci-path-d">If your panel is clean and your symptoms are minimal, the honest answer may be that food isn't your problem. That's valuable to know, and we'll tell you plainly rather than run you through a protocol with nothing to find.</div>
              </div>
            </div>
          </div>

          {/* Honest disclaimers — smaller, footnote style */}
          <div className="sci-disclaimers">
            <div className="sci-disc">
              <div>
                <div className="sci-disc-t">Human review for plan changes</div>
                <div className="sci-disc-d">Insights are generated automatically, but any recommendation to change your protocol is personally reviewed first. No automated plan decisions that bypass human judgment.</div>
              </div>
            </div>
            <div className="sci-disc">
              <div>
                <div className="sci-disc-t">A wellness program, not a diagnosis</div>
                <div className="sci-disc-d">Sensify is an educational wellness tool. It does not diagnose, treat, or cure any condition. Always consult a healthcare provider for serious or concerning symptoms.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cta-section" data-reveal>
        <h2>Test the hypothesis.</h2>
        <p>Everything you need to go from suspicion to answer, in one program.</p>
        <button className="btn-p" onClick={onGetStarted}>Start your program</button>
      </div>
      <Footer />
    </div>
  )

  if (tab === 'pricing') return (
    <div className="mk-page">
      <style>{css}</style>
      <Nav />
      <div className="mk-hero" style={{ padding: '56px 64px 12px' }}>
        <div className="mk-hero-inner sn-rise">
          <div className="mk-tag">Simple pricing</div>
          <div className="mk-h1" style={{ fontSize: '46px' }}>One program, one price.</div>
          <div className="mk-sub" style={{ marginBottom: 0 }}>No hidden fees. One flat price for the complete system.</div>
        </div>
      </div>
      <div className="mk-section alt" data-reveal>
        <div className="mk-section-inner">
          <div className="pricing-wrap">
            <div className="pricing-card">
              <div className="price-tag">The complete system</div>
              <div className="price-num">$399</div>
              <div className="price-sub">One-time payment · Lab test included</div>
              <button className="btn-p" style={{ width: '100%' }} onClick={onGetStarted}>Get started today</button>
              <div className="price-div"></div>
              {[
                'Intake survey: symptoms, baseline, and food frequency',
                'Your food sensitivity lab test, completed from home',
                'Your results read and extracted automatically',
                'Full structured elimination and reintroduction protocol',
                'Quick daily check-ins right in the app',
                '14-day reintroduction cycles with clear verdicts',
                'Ask Sensify: check any food, menu, or meal against your results',
                'Weekly symptom insights from your check-ins',
                'Compliance audit system with human review',
                'Every food ruled: your verdicts at completion',
                'Structured protocol built on the clinical standard',
              ].map((item, i) => (
                <div key={i} className="price-item">
                  <div className="p-check"><CheckIcon /></div>
                  {item}
                </div>
              ))}
              <div className="price-note">Everything included: your lab test, the full protocol, AI guidance, and your completed verdicts. No hidden costs, no separate lab bill.</div>
              {/* The refund story + the one optional add-on, at the decision
                  point (QA 2026-10-30 #3/#4): both already existed, but only
                  in terms.html and an in-app upsell a buyer never sees. */}
              <div className="price-note" style={{ marginTop: 8 }}>Not for you? Write to us and we make it right — see our Terms. After you finish, Maintain is an optional $12.99/mo companion that keeps your verdicts working day to day. Entirely optional, nothing is required beyond the one price above.</div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )

  if (tab === 'faq') return (
    <div className="mk-page">
      <style>{css}</style>
      <Nav />
      <div className="mk-hero" style={{ padding: '56px 64px 12px' }}>
        <div className="mk-hero-inner sn-rise">
          <div className="mk-tag">Questions</div>
          <div className="mk-h1" style={{ fontSize: '46px' }}>Things people ask us.</div>
          <div className="mk-sub" style={{ marginBottom: 0 }}>Everything you might want to know before you start. Still curious about something? Reach out anytime.</div>
        </div>
      </div>
      <div className="mk-section alt" data-reveal>
        <div className="mk-section-inner"><Faq /></div>
      </div>
      <div className="cta-section" data-reveal>
        <h2>Stop guessing.<br />Start knowing.</h2>
        <p>One program, one price. The test, the protocol, and the answers it earns.</p>
        <button className="btn-p" onClick={onGetStarted}>Start your program</button>
      </div>
      <Footer />
    </div>
  )

  if (tab === 'about') return (
    <div className="mk-page">
      <style>{css}</style>
      <Nav />
      <div className="mk-hero" style={{ padding: '64px 64px 48px' }}>
        <div className="mk-hero-inner sn-rise">
          <div className="mk-tag">Our story</div>
          <div className="mk-h1" style={{ fontSize: '46px' }}>I spent years guessing.<br />Sensify exists so <span style={{ color: '#3D5C3C' }}>you don't have to.</span></div>
          <div className="mk-sub" style={{ marginBottom: 0 }}>Years of feeling off, a drawer of half-read lab reports, and nobody who could say which food was actually the problem. This company started as a stubborn refusal to keep guessing.</div>
        </div>
      </div>
      <div className="mk-section alt" data-reveal>
        <div className="mk-section-inner">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '36px' }}>
            {[
              ['01 · THE GUESSING', 'Cutting foods at random', 'Dropping dairy one month, gluten the next. Feeling slightly better, never knowing why, always drifting back. No structure, no signal, no answer.'],
              ['02 · THE TEST', 'A list, then silence', 'The lab flagged a page of foods and handed over nothing else. No protocol, no guidance, no way to know which flags were real. A list is not an answer.'],
              ['03 · THE SYSTEM', 'Running it properly', 'A real elimination. Foods tested back one at a time, logged daily, judged on evidence. It worked, and it was brutal to run alone. That became the product.'],
            ].map(([n, t, d]) => (
              <div key={n} style={{ borderTop: '2.5px solid #3D5C3C', paddingTop: '18px' }}>
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', fontWeight: 500, letterSpacing: '0.17em', color: '#8BAE8A', marginBottom: '10px' }}>{n}</div>
                <div style={{ fontFamily: 'Fraunces, serif', fontSize: '21px', color: '#1C1C1C', marginBottom: '10px', lineHeight: 1.2, fontVariationSettings: "'SOFT' 60, 'WONK' 1" }}>{t}</div>
                <div style={{ fontSize: '13.5px', color: '#7A7A72', lineHeight: 1.75 }}>{d}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div data-reveal style={{ background: 'radial-gradient(120% 90% at 85% 0%, rgba(139,174,138,0.22), transparent 55%), linear-gradient(160deg, #2A3D27 0%, #1E2A1C 70%)', padding: '72px 64px', textAlign: 'center', boxShadow: 'var(--shadow-3)' }}>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: '30px', fontWeight: 300, color: '#FAF8F4', lineHeight: 1.35, maxWidth: '620px', margin: '0 auto', fontVariationSettings: "'SOFT' 60, 'WONK' 1" }}>The test was easy to buy. The answer took a system. <span style={{ color: '#8BAE8A' }}>So I built the system.</span></div>
      </div>
      <div className="mk-section cream" data-reveal>
        <div className="mk-section-inner" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '30px', flexWrap: 'wrap' }}>
          <div style={{ maxWidth: '460px' }}>
            <div style={{ fontFamily: 'Fraunces, serif', fontSize: '24px', color: '#1C1C1C', lineHeight: 1.25, fontVariationSettings: "'SOFT' 60, 'WONK' 1" }}>Every verdict we issue is the one <span style={{ color: '#3D5C3C' }}>we never got.</span></div>
            <div style={{ fontSize: '13.5px', color: '#7A7A72', lineHeight: 1.7, marginTop: '10px' }}>Sensify exists to turn a suspicion into a ruling: Safe, Limit, or Avoid, earned from your own body's evidence. No guessing. No drifting back.</div>
          </div>
          <button className="mk-cta" onClick={onGetStarted} style={{ padding: '14px 26px', fontSize: '14px', borderRadius: '12px' }}>Start your program</button>
        </div>
      </div>
      <Footer />
    </div>
  )

  return null
}
